module.exports = __webpack_public_path__ + "img/pro-p-slider25.1a1d92b6.jpg";